import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "My first longboarding event",
  "description": "",
  "published": "2012-08-09T00:00:00.000Z",
  "redirect_from": ["/blog/my-first-longboarding-event/swizec/5030"],
  "categories": "freeride, Longboard, Recreation, Skateboard, slide, Sports, Travel + Events",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://vimeo.com/47120988"
      }}>{`PreBear 2012`}</a>{` from `}<a parentName="p" {...{
        "href": "http://vimeo.com/brosbeforepros"
      }}>{`Bros Before Pros`}</a>{` on `}<a parentName="p" {...{
        "href": "http://vimeo.com"
      }}>{`Vimeo`}</a>{`.`}</p>
    <p>{`The guys in that video are setting up the tracks for `}<a parentName="p" {...{
        "href": "http://knk.longboard.si/knk-longboard-camp-2012/"
      }}>{`KnK longboard camp`}</a>{` starting in four days. 2000 bales of hay, a bunch of turns, tarmac smooth as a baby's behind and just over two kilometers of curves so beautiful they make your head spin.`}</p>
    <p>{`Yesterday they held a freeride event on that track. As a warmup to the camp no doubt. All you had to do to participate was become a member of the club thingy.`}</p>
    <p>{`It was easily the best day I've had all summer. If I had to choose I would gladly give both `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/geek-at-a-music-festival-day-1/swizec/4825",
        "title": "Geek at a music festival: Day 1"
      }}>{`EXIT`}</a>{` and `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/a-roadtrip-fin/swizec/4972",
        "title": "A roadtrip: fin"
      }}>{`The Roadtrip`}</a>{` for this one day of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Longboarding",
        "title": "Longboarding"
      }}>{`longboarding`}</a>{`. Coming home from those two I was so tired I needed a few days to recover, coming home yesterday evening I was so pumped and excited I could jump through the ceiling.`}</p>
    <p>{`Then I collapsed into bed and died for almost 8 hours (a lot for me) out of pure physical exhaustion.`}</p>
    <h2 {...{
      "id": "the-riding"
    }}>{`The riding`}</h2>
    <p>{`The road was closed. Good.`}</p>
    <p><img parentName="p" {...{
        "src": "https://distilleryimage8.instagram.com/b14d7c5ae18311e1a24f1231381b4d9b_7.jpg",
        "alt": "The finish line",
        "title": "The finish line"
      }}></img></p>
    <p>{`Hard objects covered in hay. Good.`}</p>
    <p>{`An ambulance on stand by. Awesome.`}</p>
    <p>{`A shuttle takes you back up. Epic.`}</p>
    <p>{`As usually happens when I get the feeling of safety during adrenaline sports I lose all sense of self-preservation. Well most of it anyway. I took a major-ish spill on ~8 out of my ~10 runs and a few minor spills every couple of curves. Oh yeah, FUN!`}</p>
    <p>{`But I learned a lot!`}</p>
    <p><img parentName="p" {...{
        "src": "https://distilleryimage4.instagram.com/ceeb67cce18d11e1bde812313b08e061_7.jpg",
        "alt": "Oh glorious roadburn",
        "title": "Oh glorious roadburn"
      }}></img></p>
    <p>{`My carving is now juuuuuuuust on the verge of stand-up slides -> fell on my back twice, when the board slipped too much.`}</p>
    <p>{`My `}<a parentName="p" {...{
        "href": "http://www.youtube.com/watch?v=SKzBtWDWMX4"
      }}>{`coleman slides`}</a>{` turn all the way back to driving position, but I don't know how to stand back up again. So they're almost speed checks. Almost. This resulted in many tumbles onto my back and elbows and sort of doing summersaults at moderate speeds.`}</p>
    <p>{`One of them was recorded, but I don't have the video. It was interesting though, apparently I made a slide, tumbled, got on my feet, ran after the still moving board, hopped on and continued riding.`}</p>
    <p>{`Oh and one time my board fell off the road and into a ditch so deep I needed help getting down there.`}</p>
    <p>{`The absolute worst, was that time I nearly killed a fellow longboarder. She was passing me, so I stopped carving to give her enough room. Doing this made me go so fast she couldn't pass me, but I did get `}<em parentName="p">{`insane`}</em>{` wobbles. Was forced to do a botched slide, which nearly swept her off the road. Threw myself on my side and slid to a stop about five meters later.`}</p>
    <p>{`She stopped with a slide about a hundred meters later. And was so nice she even asked if I got hurt, even though I was the one who almost killed `}<em parentName="p">{`her`}</em>{`.`}</p>
    <p>{`Anyway, I had epic fun, it was a bloody awesome day and I think it's time to invest in some knee and elbow pads.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/08/photo4.jpeg",
        "alt": "20 people+gear can fit in the shuttle",
        "title": "20 people+gear can fit in the shuttle"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://woodpluswheels.com/2012/07/23/promenade-cruising/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/102092034_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://woodpluswheels.com/2012/07/23/promenade-cruising/"
        }}>{`Promenade cruising`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.livestrong.com/article/555442-what-are-the-health-benefits-of-longboarding/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/95052131_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.livestrong.com/article/555442-what-are-the-health-benefits-of-longboarding/"
        }}>{`What Are the Health Benefits of Longboarding?`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://woodpluswheels.com/2012/08/02/longboard-distribution-in-the-uk/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/104226065_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://woodpluswheels.com/2012/08/02/longboard-distribution-in-the-uk/"
        }}>{`Longboard distribution in the UK`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.livestrong.com/article/553785-how-to-do-a-toeside-slide-on-a-longboard/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/95052763_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.livestrong.com/article/553785-how-to-do-a-toeside-slide-on-a-longboard/"
        }}>{`How to Do a Toeside Slide on a Longboard`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.highsnobiety.com/2012/07/21/longboard-girl-by-sonia-szostak/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/101796259_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.highsnobiety.com/2012/07/21/longboard-girl-by-sonia-szostak/"
        }}>{`Longboard Girl by Sonia Szóstak`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.news.com.au/national/police-struggle-to-stop-longboard-riders-dicing-with-death-on-mount-gravatt-mountain/story-e6frfkvr-1226391514285?from=public_rss"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/93617268_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.news.com.au/national/police-struggle-to-stop-longboard-riders-dicing-with-death-on-mount-gravatt-mountain/story-e6frfkvr-1226391514285?from=public_rss"
        }}>{`Daredevils dicing with death on downhill run`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=bfd96e04-690a-4943-a095-6f9893c5752f",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      